export const state = () => ({
	job: null,
	job_tab: 'job',
});

export const mutations = {
	setJobSingle(state: any, payload: any) {
		state.job = payload;
	},
	setJobTab(state: any, payload: any) {
		state.job_tab = payload;
	},
};

export const getters = {
	getJobSingle: (state: any) => state.job,
	getJobTab: (state: any) => state.job_tab,
};

export const actions = {
	toggleFavourite(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/jobs/' + payload.uuid + '/favourite-toggle')
				.then((res) => {
					let clone = JSON.parse(
						JSON.stringify(state.rootState.jobs.filtered_jobs),
					);

					if (
						this.$router.history.current.path ===
						this.localePath({ path: '/saved-jobs' })
					) {
						let j = clone?.data.find(
							(object) => object.uuid === payload.uuid,
						);

						if (j) {
							clone?.data.splice(clone?.data.indexOf(j), 1);
						}
					} else {
						clone?.data.find((object, index) => {
							if (object.uuid === payload.uuid) {
								clone.data[index].favourite =
									!clone.data[index].favourite;
							}
						});
					}
					this.dispatch('jobs/setFilteredJobs', clone);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getJobSingle(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/jobs/' + payload)
				.then((res) => {
					state.commit('setJobSingle', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	setJobSingle(state: any, payload: any) {
		state.commit('setJobSingle', payload);
	},

	setJobTab(state: any, payload: any) {
		state.commit('setJobTab', payload);
	},
};
